import { defaultHttpClient } from '../../httpClient';
import type { GetMemberRequestsAvailabilityResponse } from './types';

export const getMemberRequestsAvailability = (
  marketSno: number,
  type?: number,
) => {
  return defaultHttpClient
    .request<GetMemberRequestsAvailabilityResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketSno}/member-requests/availability/`,
      params: {
        type: type ?? 0,
      },
    })
    .then(result => result.data);
};
